/**
 * admin-studiomate-schedules.ts - Admin용 Studiomate 스케줄 조회 서비스
 *
 * getStudiomateSchedules Cloud Function을 호출하여 특정 센터의 스케줄을 조회한다.
 * admin은 centerId를 명시적으로 전달하여 다중 센터 환경에서도 정확한 센터의 스케줄을 가져온다.
 */

import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";
import type { GetStudiomateSchedulesResponse } from "@vlab-corporation/studiomate-api";

/**
 * 특정 센터의 Studiomate 스케줄을 조회한다.
 *
 * @param centerId - 센터 ID
 * @param startDate - 시작 날짜 (YYYY-MM-DD)
 * @param endDate - 종료 날짜 (YYYY-MM-DD)
 * @returns 스케줄 응답
 */
export async function fetchAdminStudiomateSchedules(
  centerId: number,
  startDate: string,
  endDate: string,
): Promise<GetStudiomateSchedulesResponse> {
  const fn = httpsCallable<
    {
      centerId: number;
      startDate: string;
      endDate: string;
    },
    GetStudiomateSchedulesResponse
  >(getFirebaseFunctions(), "getStudiomateSchedules");

  const result = await fn({
    centerId,
    startDate,
    endDate,
  });
  return result.data;
}
